module.exports = __webpack_public_path__ + "fonts/TradeGothicLTStd-Bold.73b2bf8.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TradeGothicLTStd-Bold.otf
// module id = ./src/assets/fonts/TradeGothicLTStd-Bold.otf
// module chunks = 34